import { supabase } from '../supabaseClient';

export const fetchBonusTypes = async () => {
  const { data, error } = await supabase.from('bonustype').select('*').order('name', { ascending: true });
  if (error) {
    alert(`Error fetching bonus types: ${error.message}`);
    throw error;
  }
  return data;
};

export const fetchBonus = async (clientId) => {
  const { data, error } = await supabase
    .from('bonus')
    .select(
      `
          id,
          created_at,
          price,
          quantityofclasses,
          from_date,
          to_date,
          bonustype (
            id,
            name,
            monthbased
          )
        `
    )
    .eq('user_id', clientId)
    .order('id', { ascending: true });

  if (error) {
    alert(`Error fetching bonus: ${error.message}`);
    throw error;
  }
  return data;
};

export const deleteBonus = async (bonusId) => {
  const { error } = await supabase.from('bonus').delete().eq('id', bonusId);
  if (error) {
    alert(`Error deleting bonus: ${error.message}`);
    throw error;
  }
};

export const deleteBonusType = async (bonusTypeId) => {
  const { error } = await supabase.from('bonustype').delete().eq('id', bonusTypeId);
  if (error) {
    alert(`Error deleting bonus: ${error.message}`);
    throw error;
  }
};


export const addUpdateBonusType = async (bonusType, bonusTypeId) => {
  const { error } = bonusTypeId
    ? await supabase.from('bonustype').update(bonusType).eq('id', bonusTypeId)
    : await supabase.from('bonustype').insert([bonusType]);

  if (error) {
    alert(`Error saving: ${error.message}`);
    throw error;
  }
  return true;
};

// Returns true only if the user has had a real (non-trial) bonus
export const hasEverHadBonus = async (userId) => {
  const { data, error } = await supabase
    .from('bonus')
    .select('id')
    .eq('user_id', userId)
    .or('status.is.null,status.neq.pending_trial')
    .limit(1);
  if (error) return false;
  return data.length > 0;
};

export const hasPendingTrial = async (userId) => {
  const { data, error } = await supabase
    .from('bonus')
    .select('id')
    .eq('user_id', userId)
    .eq('status', 'pending_trial')
    .limit(1);
  if (error) return false;
  return data.length > 0;
};

export const createTrialBonus = async (userId, bonusTypeId, price, classDate) => {
  const { data, error } = await supabase
    .from('bonus')
    .insert([{
      bonustype: bonusTypeId,
      price: price ?? 0,
      quantityofclasses: 1,
      user_id: userId,
      from_date: classDate,
      to_date: classDate,
      status: 'pending_trial',
    }])
    .select()
    .single();
  return { data, error };
};
